import { useEffect, useState } from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

// for the carousel
import "react-multi-carousel/lib/styles.css";

import OnePerson from "./OnePerson";
import SponsorCardHeader from "./SponsorCardHeader";
import image1Big from "../../../assets/SponsorBanner.png";
import image1Small from "../../../assets/SponsorBannerMobile.png";
import sponsorsData from "../data/sponsors.json";

export const SponsorCards = () => {
   const [allInfo, setAllInfo] = useState([]);
   const [isBig, setIsBig] = useState(true);

   window.addEventListener("resize", handleResize);

   function handleResize(event) {
      var newWidth = window.innerWidth;
      if (newWidth > 1000) {
         setIsBig(true);
      } else {
         setIsBig(false);
      }
      return function cleanupListener() {
         window.removeEventListener("resize", handleResize);
      };
   }

   useEffect(() => {

      let result = sponsorsData.map(display_name => display_name.values);
      let filteredResult = result.filter(x => x[0].display_name !== "industry partner");
      setAllInfo(filteredResult);
   }, []);



   return (
      <>
         <div>
            {isBig ? (
               <img
                  src={"./assets/events/fvs22/SponsorBanner.png"}
                  alt="banner"
                  style={{ height: "100%", width: "100%" }}
               />
            ) : (
               <img
                  src={"./assets/events/fvs22/SponsorBannerMobile.png"}
                  alt="banner"
                  style={{ height: "100%", width: "100%" }}
               />
            )}
         </div>
         <div
            className="web-sponsor-view"
            style={{ marginBottom: "2.5vh", background: "white" }}
         >
            <div
               className={`${isBig ? "container" : "container-fluid"} sponsor-card`}
               style={{
                  fontFamily: "Roboto Condensed, sans-serif !important",
               }}
            >
               <h1
                  style={{
                     position: "absolute",
                     left: "0",
                     fontSize: "24px",
                     width: "100%",
                     textAlign: "center",
                     fontWeight: "900",
                     color: "white",
                     background: "black",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     padding: "15px 12px",
                  }}
               >
                  Sponsored by the Greatest Leaders in their Fields
               </h1>
               {/* should be an image here  */}

               <div style={{ backgroundColor: "white", padding: "50px 0px" }}>
                  {isBig || document.innerWidth < 900
                     ? allInfo?.map((singleCategory, index) => {
                        
                           return (
                              <div style={{ color: "black" }}>
                                 {singleCategory?.map((singleObject, index) => {
                                    const {
                                       description,
                                       // id,
                                       logo_url,
                                       name,
                                       display_name,
                                       team_members,
                                       website,
                                    } = singleObject;
                                    return (
                                       <div
                                          style={{
                                             border: "3px solid blue",
                                             margin: index === 0 ? "70px 30px 30px 30px" : "30px 30px",
                                             padding: "30px 40px",
                                          }}
                                       >
                                          <div className="row" style={{ alignItems: 'top' }}>
                                             <div className="col-lg-3 ">
                                                <SponsorCardHeader
                                                   display_name={display_name}
                                                   website={website}
                                                   logo_url={logo_url}
                                                   name={name}
                                                />
                                             </div>
                                             <div className="col-lg-8 col-sm-12 peoplePlace">
                                                <div>
                                                   {JSON.parse(team_members).length > 0 && (
                                                      <div className="col-12 d-flex justify-content-center align-items-center mt-2 flexPeople" style={{ width: window.innerWidth > 900 && '90%', margin: 'auto', gap: '5%' }}>
                                                         {JSON.parse(team_members).map(
                                                            (teamMember) => {
                                                               const {
                                                                  headshot_url,
                                                                  firstname,
                                                                  lastname,
                                                                  jobtitle,
                                                                  linkedin,
                                                               } = teamMember;
                                                               const name =
                                                                  firstname + " " + lastname;
                                                               return (
                                                                  <div className="d-flex justify-content-center align-items-center">
                                                                     <div>
                                                                        <OnePerson
                                                                           style={{
                                                                              PointerEvent:
                                                                                 "none !importent",
                                                                           }}
                                                                           imgSrc={headshot_url}
                                                                           name={name}
                                                                           position={jobtitle}
                                                                           LinkedInIcon={LinkedInIcon}
                                                                           linkedin={linkedin}
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               );
                                                            }
                                                         )}
                                                      </div>
                                                   )}
                                                </div>
                                                <div className="row mt-2 desc">
                                                   {description}
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    );
                                 })}
                              </div>
                           );
                        
                     })
                     : 

                     allInfo.map((singleCategory, index) => {
                        
                           return (
                              <div style={{ color: "black" }}>
                                 {singleCategory.map((singleObject, index) => {
                                    const {
                                       description,
                                       // id,
                                       logo_url,
                                       name,
                                       display_name,
                                       team_members,
                                       website,
                                    } = singleObject;
                                    return (
                                       <div
                                          className="oneCard"
                                          style={{
                                             border: "3px solid blue",
                                             margin: index === 0 ? "70px 30px 30px 30px" : "30px 30px",
                                             padding: "30px 40px",
                                          }}
                                       >
                                          <div className="row align-items-center">
                                             <div className="col-lg-3 col-sm-12 moveCenter">
                                                <SponsorCardHeader
                                                   display_name={display_name}
                                                   website={website}
                                                   logo_url={logo_url}
                                                   name={name}
                                                />
                                             </div>
                                             <div className="col-lg-8 col-sm-12 peoplePlace">
                                                <div>
                                                   {JSON.parse(team_members).length > 0 && (
                                                      <div className="col-12 d-flex mt-2 peopleSmallScreen" style={{ justifyContent: JSON.parse(team_members).length === 1 ? "center" : "left" }} >
                                                         {JSON.parse(team_members).map(
                                                            (teamMember) => {
                                                               const {
                                                                  headshot_url,
                                                                  firstname,
                                                                  lastname,
                                                                  jobtitle,
                                                                  linkedin,
                                                               } = teamMember;
                                                               const name =
                                                                  firstname + " " + lastname;
                                                               return (
                                                                  <OnePerson
                                                                     imgSrc={headshot_url}
                                                                     name={name}
                                                                     position={jobtitle}
                                                                     LinkedInIcon={LinkedInIcon}
                                                                     linkedin={linkedin}
                                                                  />
                                                               );
                                                            }
                                                         )}
                                                      </div>
                                                   )}
                                                </div>
                                                <div className="row mt-2 desc">
                                                   {description}
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    );
                                 })}
                              </div>
                           );
                        
                     })}
               </div>
            </div>
         </div>
      </>
   );
};
